'use strict';

import scrollToElement from 'helpers/scrollToElement';

const PD_CLASSNAME = 'product-detail__description';
const PD_TRUNCATE_DATA = 'data-truncated';

const ProductDescriptions = {
  init: function(description) {

    if(!description.hasAttribute(PD_TRUNCATE_DATA)) {
      const parent = description.parentNode;
      this.setupTruncation(description, parent);
    }
  },

  setupTruncation: function(description, parent) {
    const truncatedClass = `${PD_CLASSNAME}--truncated`;
    const canTrucateClass = `${PD_CLASSNAME}--can-truncate`;
    description.classList.remove(truncatedClass);
    description.classList.add(canTrucateClass);

    const innerEl = description.querySelector(`.${PD_CLASSNAME}-inner`);
    const contentHeight = innerEl.offsetHeight;

    const mobileThreshold = 340;
    const mobileLandscapeThreshold = 300;
    const tabletThreshold = 320;
    const desktopThreshold = 300;

    const mobileQuery = '(max-width: 567px)';
    const mobileLandscapeQuery = '(min-width: 568px) and (max-width: 767px)';
    const tabletQuery = '(min-width: 768px) and (max-width: 1023px)';
    const desktopQuery = '(min-width: 1024px)';

    const truncateMobile = (contentHeight >= mobileThreshold && this.checkMedia(mobileQuery));
    const truncateMobileLandscape = (contentHeight >= mobileLandscapeThreshold && this.checkMedia(mobileLandscapeQuery));
    const truncateTablet = (contentHeight >= tabletThreshold && this.checkMedia(tabletQuery));
    const truncateDesktop = (contentHeight >= desktopThreshold && this.checkMedia(desktopQuery));

    if(truncateMobile || truncateMobileLandscape || truncateTablet || truncateDesktop) {
      description.classList.add(truncatedClass);
      description.setAttribute(PD_TRUNCATE_DATA, true);
      this.appendButton(description, parent);
    }
  },

  appendButton: function (description, parent) {
    const controlID = (description.id) ? description.id : `description-toggle-${Math.floor(Math.random() * 100) + 1  }`;
    const moreButton = document.createElement('button');

    moreButton.innerHTML = 'Show more';
    moreButton.classList.add(`${PD_CLASSNAME}-toggle`);

    moreButton.setAttribute('aria-expanded', false);
    moreButton.setAttribute('aria-controls', controlID);

    parent.appendChild(moreButton);
    description.id = controlID;

    moreButton.addEventListener('click', (e) => {
      e.preventDefault();

      this.toggleTruncation(description, parent);
    });
  },

  toggleTruncation: function(description, parent) {
    const isTruncated = description.getAttribute(PD_TRUNCATE_DATA) === 'true';
    const button = parent.querySelector(`.${PD_CLASSNAME}-toggle`);

    if(isTruncated) {
      document.body.dispatchEvent(
        new CustomEvent('dataStateChange', {
          detail : {
            action: 'pdp.accordionClick',
            type: 'product description'
          }
        })
      )
    }

    this.toggleButtonState(button, isTruncated);
    this.togglePanelState(description, isTruncated);

    if(!isTruncated) {
      scrollToElement(parent.parentNode, 0, 1);
    }
  },

  togglePanelState: function (description, isTruncated) {
    description.classList.toggle(`${PD_CLASSNAME}--truncated`);
    description.setAttribute(PD_TRUNCATE_DATA, !isTruncated);
  },

  toggleButtonState: function(button, isTruncated) {
    const text = isTruncated ? 'Show less' : 'Show more';

    button.setAttribute('aria-expanded', isTruncated);
    button.innerHTML = text;
  },

  checkMedia: function(query) {
    return window.matchMedia(query).matches;
  },
};

export default () => {
  const productDescription = document.querySelector(`.${PD_CLASSNAME}[data-truncate]`);

  if(productDescription) {
    ProductDescriptions.init(productDescription);
  }
};
